module.exports = __webpack_public_path__ + "img/thickbackarrow.f58e5f1d.svg";